import * as yup from 'yup';
import { eInternalOrderStatus } from '../../../../ui-toolkit/enums/eInternalOrderStatus';
import { eUSAState } from '../../../../ui-toolkit/enums/states';
import { eTransactionCategory } from '../../../../ui-toolkit/enums/eTransactionType';

const transactionCategories = Object.values(eTransactionCategory);
const orderStatuses = Object.values(eInternalOrderStatus);
const states = Object.values(eUSAState);

// a dateString can be an empty string.
// the month of the dateString can be 1 or 2 digits.
// the month of the dateString cannot be greater than 12
// the date of the dateString can be 1 or 2 digits
// the date of the dateString cannot be greater than 31
// the year of the dateString must be 4 digits. Spruce did not exist before the Battle of Hastings :-)

// const dateStringRegEx = /^(|((0?[1-9]|1[0-2])\/([0-2]?[1-9]|[12][0-9]|3[01])\/\d{4}))$/;

// Helper for base date validation
const dateField = (label: string) =>
  yup
    .date()
    .transform((_, originalValue) => (originalValue === '' ? null : new Date(originalValue)))
    .nullable()
    .typeError(`Invalid ${label}`);

// Helper for end date with comparison
const endDateField = (startKey: string, label: string) =>
  dateField(label).test('is-after-start', `${label} must be after start date`, function (value) {
    const startValue = this.parent[startKey];
    return !startValue || !value || new Date(value) >= new Date(startValue);
  });

export const dashboardFilterValidation = yup.object().shape({
  internalContacts: yup.array(yup.string().uuid()),
  clientCompanies: yup.array(yup.string().uuid()),
  transactionCategories: yup.array().of(yup.mixed().oneOf(transactionCategories)),
  orderStatuses: yup.array().of(yup.mixed().oneOf(orderStatuses)),
  states: yup.array().of(yup.mixed().oneOf(states)),

  closingDateStart: dateField('closing start date'),
  closingDateEnd: endDateField('closingDateStart', 'closing end date'),

  createdAtStart: dateField('created start date'),
  createdAtEnd: endDateField('createdAtStart', 'created end date'),
});
